import "./PreviewQuote.scss";

const PREVIEW_TEXT_MAX_LENGTH = 100;

/**
 * Renders the annotated text as a quoted preview, truncated to
 * `PREVIEW_TEXT_MAX_LENGTH` characters with an ellipsis. Renders nothing
 * when `text` is empty/undefined.
 *
 * @param {Object} props
 * @param {string} [props.text] - Annotated text to preview.
 * @returns {JSX.Element | null}
 */
export default function PreviewQuote({ text, className = "" }) {
  const previewText = text
    ? text.length > PREVIEW_TEXT_MAX_LENGTH
      ? text.slice(0, PREVIEW_TEXT_MAX_LENGTH) + "…"
      : text
    : null;

  if (!text) return null;
  return (
    <div className={`previewQuote font-italic p-3 rounded mb-3 ${className}`}>
      &ldquo;{previewText}&rdquo;
    </div>
  );
}
